
const getUserDetails = () => window.user_details || { logged_in_state: 'logged_out', user_id: '' }

export const registerPageview = (url, title) =>  {

  const user = getUserDetails();

  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    'event': 'virtual_page_view',
    'page_path': url,
    'page_title': title,
    'user': {
      'logged_in_state': user.logged_in_state,
      'user_id': user.user_id,
    },
  })
}
  